/* eslint-disable @typescript-eslint/no-unused-vars */
import { storageToken } from './storage';
import history from 'src/history/history';
import { ApiUrlEnum, ErrorUrlEnum } from './enum';
import { IAuthUser } from 'src/redux/features/auth/types';
import { PublicRoutesEnum } from './router';
import { saveAs } from 'file-saver';

const location: string = process.env.REACT_APP_API_URL;

export const locationNotApi: string = process.env.REACT_APP_NOT_API_URL;

const buildParamsPostNew = (met: string, data: any) => ({
  method: met,
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(data),
});

const buildParamsImagePost = (met: string, data?: any) => {
  return {
    method: met,
    headers: {
      Authorization: `Bearer ${storageToken()}`,
    },
    body: data,
  };
};

const buildParamsPost = (met: string, data?: any) => {
  if (data) {
    return {
      method: met,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${storageToken()}`,
      },
      body: JSON.stringify(data),
    };
  }
  return {
    method: met,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${storageToken()}`,
    },
  };
};

const buildParams = (met: string) => ({
  method: met,
  headers: { Authorization: `Bearer ${storageToken()}` },
});

export async function downloadFile(response: any) {
  localStorage.setItem('status', response.status);
  const status = String(response.status).substring(0, 1);
  if (status === '2') {
    // Extract filename from header
    const contentDisp = response.headers.get('Content-Disposition').split(';');
    const fileRu = contentDisp.find((n: string | string[]) =>
      n.includes('filename*'),
    );
    let filename;
    if (fileRu) {
      const newFile = fileRu
        .replace("filename*=UTF-8''", '')
        .replace(`filename*="UTF-8''`, '')
        .replace(/"/g, '')
        .trim();
      filename = decodeURI(newFile).replace('%2F', '/');
    } else {
      filename = contentDisp
        .find((n: string | string[]) => n.includes('filename'))
        .replace('filename=', '')
        .replace(/"/g, '')
        .trim();
    }
    const blob = await response.blob();

    // Download the file
    saveAs(blob, filename);
  } else {
    return Promise.reject(response);
  }
}

const handleResponse = async (res: any) => {
  localStorage.setItem('status', res.status);
  const status = String(res.status).substring(0, 1);
  if (status === '2') {
    const data = (await res.json()) as Promise<any>;
    return data;
  } else {
    return Promise.reject(res);
  }
};

const handleError = async (res: any) => {
  const data = (await res.json()) as Promise<any>;
  const status = String(res.status).substring(0, 1);
  if (res.status === 401) {
    localStorage.clear();
    history.push(PublicRoutesEnum.AUTH);
  } else if (res.status === 403) {
    history.replace(ErrorUrlEnum.ERROR_403);
  } else if (res.status === 404) {
    history.replace(ErrorUrlEnum.ERROR_404);
  } else if (res.status === 503) {
    history.replace(ErrorUrlEnum.ERROR_503);
  } else if (parseInt(String(res.status / 100)) === 500) {
    history.push(ErrorUrlEnum.ERROR_500);
  }
  throw data;
};

const postNew = (url: string, data: any) =>
  fetch(location + url, buildParamsPostNew('POST', data))
    .then(handleResponse)
    .catch(handleError);
const post = (url: string, data?: any) =>
  fetch(location + url, buildParamsPost('POST', data))
    .then(handleResponse)
    .catch(handleError);
const postIm = (url: string, data?: any) =>
  fetch(location + url, buildParamsImagePost('POST', data))
    .then(handleResponse)
    .catch(handleError);
const get = (url: string) =>
  fetch(location + url, buildParams('GET'))
    .then(handleResponse)
    .catch(handleError);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const put = (url: string) =>
  fetch(location + url, buildParams('PUT'))
    .then(handleResponse)
    .catch(handleError);
const putPost = (url: string, data: any) =>
  fetch(location + url, buildParamsPost('PUT', data))
    .then(handleResponse)
    .catch(handleError);
const del = (url: string) =>
  fetch(location + url, buildParams('DELETE'))
    .then(handleResponse)
    .catch(handleError);
const download = (url: string) =>
  fetch(location + url, buildParams('GET'))
    .then(downloadFile)
    .catch(handleError);

export default {
  loadAuthUser: (auth: IAuthUser) => postNew(ApiUrlEnum.USER_AUTH, auth),
  loadUserInfo: (id: string | number) => get(`${ApiUrlEnum.USER_INFO}${id}`),
  loadLogoutUser: () => post(ApiUrlEnum.USER_LOGOUT),
  loadUserInit: () => get(ApiUrlEnum.USER_INIT),
  loadAllSurvey: () => get(ApiUrlEnum.ALL_SURVEY),
  loadOneSurvey: (id: number) => get(`${ApiUrlEnum.ALL_SURVEY}/${id}`),
  loadCreateSurvey: () => post(ApiUrlEnum.CREATE_SURVEYS),
  loadEditSurvey: (editServiys: any, id: number) =>
    putPost(`${ApiUrlEnum.CREATE_SURVEYS}/${id}`, editServiys),
  loadAddImages: (td: any) => postIm(ApiUrlEnum.ADD_IMAGES, td),
  loadDeleteImagesSurveys: (id: number) =>
    del(`${ApiUrlEnum.DELETE_IMAGES}/${id}`),
  loadCreateQuestion: (id: number, data: any) =>
    post(`/constructor/surveys/${id}/questions`, data),
  loadAllListQuestions: (id: number) =>
    get(`/constructor/surveys/${id}/questions`),
  loadDeleteSurvey: (id: number) => del(`${ApiUrlEnum.DELETE_SURVEY}/${id}`),
  loadAllTag: () => get(ApiUrlEnum.ALL_TAG),
  loadPublishSurvey: (id: number, data: any) =>
    putPost(`${ApiUrlEnum.PUBLISH_SURVEY}/${id}/status`, data),
  loadDuplicateSurvey: (id: string | number) =>
    post(`${ApiUrlEnum.CONSTRUCTOR_SURVEYS}/${id}${ApiUrlEnum.DUPLICATE}`),
  loadDeleteQuestion: (idSurvey: number, idQuestion: number) =>
    del(`${ApiUrlEnum.DELETE_SURVEY}/${idSurvey}/questions/${idQuestion}`),
  loadEditQuestion: (idSurvey: number, idQuestion: number, data: any) =>
    putPost(
      `${ApiUrlEnum.DELETE_SURVEY}/${idSurvey}/questions/${idQuestion}`,
      data,
    ),
  loadSortedQuestion: (id: number, data: any) =>
    putPost(`${ApiUrlEnum.DELETE_SURVEY}/${id}/questions-sorted`, data),
  takingSurvey: (hash: string) => get(ApiUrlEnum.TAKING_SURVEY + hash),
  putTakingSurvey: (hash: string, data: any) =>
    putPost(ApiUrlEnum.TAKING_SURVEY + hash, data),
  loadImportSurvey: (data: any) => postIm(ApiUrlEnum.IMPORT_SURVEY, data),
  loadAnalytic: (id: string | number) =>
    get(`${ApiUrlEnum.ANALYTIC}${id}/json`),
  unloadSurvey: (id: string | number) =>
    download(`${ApiUrlEnum.ANALYTIC}${id}/excel`),
  loadMySurveys: (user_id: string | number) =>
    get(`${ApiUrlEnum.USER_USERS}/${user_id}${ApiUrlEnum.COMPLETED_SURVEYS}`),
  unloadExample: () => download(ApiUrlEnum.IMPORT_EXAMPLE),
};
